import {
  QDeleteConfirmationModal,
  QFormControl,
  QSpinner,
  QStack,
  QSwitch,
  QText,
  useCurrentUser,
  useToastProvider,
} from '@qualio/ui-components';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery, useQueryClient } from 'react-query';
import { CacheKeys } from '../../../types';
import { getCompanyFromMedtech, updateCompanyMfa } from '../../../api/medtech-api';
import { createErrorToast } from '../../../utils/toast.utils';

const Security: React.FC = () => {
  const currentUser = useCurrentUser();
  const { t } = useTranslation();
  const { showToast } = useToastProvider();
  const queryClient = useQueryClient();
  const [showConfirmation, setShowconfirmation] = useState(false);

  const { isLoading, data } = useQuery([CacheKeys.AUTHENTICATION, currentUser.companyId], () =>
    getCompanyFromMedtech(currentUser.companyId),
  );

  if (isLoading || data === undefined) {
    return <QSpinner size="sm" />;
  }

  const onConfirm = (mfaMandatory: boolean) => {
    updateCompanyMfa(currentUser.companyId, mfaMandatory)
      .then(() => {
        queryClient.invalidateQueries({ queryKey: [CacheKeys.AUTHENTICATION, currentUser.companyId] });
        setShowconfirmation(false);
      })
      .catch(() => {
        showToast(createErrorToast(t('messages.error.updateMfa'), 'security-mfa-update-error-toast'));
      });
  };

  const onToggle = (event: any) => {
    if (event.target.checked === false) {
      setShowconfirmation(true);
    } else {
      onConfirm(event.target.checked);
    }
  };

  return (
    <QStack spacing={4}>
      <QText fontSize="sm">{t('security.description')}</QText>
      <QFormControl
        label={t('security.mfa.label')}
        isInvalid={false}
        helper={t('security.mfa.description')}
        data-cy="mfa-enable"
      >
        <QSwitch
          id="mfa-switch"
          data-cy="mfa-enable-switch"
          data-testid="mfa-enable-switch"
          rightLabel={t('security.mfa.enable')}
          isDisabled={isLoading}
          isChecked={data.mfaRequired}
          onChange={onToggle}
        >
          {' '}
        </QSwitch>
      </QFormControl>
      {showConfirmation && (
        <QDeleteConfirmationModal
          onConfirm={() => onConfirm(false)}
          onClose={() => setShowconfirmation(false)}
          title={t('security.mfa.disableTitle')}
          message={<div>{t('security.mfa.disableMessage')}</div>}
        />
      )}
    </QStack>
  );
};

export default Security;
